<script setup lang="ts">
import '../../styles/troodon/_variables.scss'

import IconChevronLeftLine from '~/components/icon/chevron-left-line.vue'
import IconXLine from '~/components/icon/x-line.vue'

defineProps<{
  showBack?: boolean
  showClose?: boolean
}>()

const emit = defineEmits<{
  back: []
  close: []
}>()

const ICON_COLOR = '#191c24'
</script>

<template>
  <header class="troodon-nav" v-bind="$attrs">
    <button
      v-if="showBack"
      class="troodon-nav__icon-button"
      type="button"
      aria-label="戻る"
      @click="emit('back')"
    >
      <IconChevronLeftLine :size="24" :color="ICON_COLOR" />
    </button>
    <span v-else class="troodon-nav__icon-placeholder"></span>
    <h1 class="troodon-nav__title"><slot></slot></h1>
    <button
      v-if="showClose"
      class="troodon-nav__icon-button"
      type="button"
      aria-label="閉じる"
      @click="emit('close')"
    >
      <IconXLine :size="24" :color="ICON_COLOR" />
    </button>
    <span v-else class="troodon-nav__icon-placeholder"></span>
  </header>
</template>

<style scoped lang="scss">
.troodon-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid var(--troodon-c-border-low);
  background-color: var(--troodon-c-white);
}

.troodon-nav__icon-button,
.troodon-nav__icon-placeholder {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background-color: transparent;
}

.troodon-nav__icon-button {
  cursor: pointer;
}

.troodon-nav__title {
  flex: 1 0 0;
  min-width: 1px;
  margin: 0;
  color: var(--troodon-c-text-high);
  font-size: var(--troodon-f-size-lg);
  font-weight: 700;
  line-height: var(--troodon-lh-button);
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
